import { Navigate, Outlet } from 'react-router-dom';
// hooks
import { useOtpSession } from '../hooks/use-otp-session';

// ----------------------------------------------------------------------

type Props = {
  children?: React.ReactNode;
};

export default function OtpGuard({ children }: Props) {
  const { getOtpMobile } = useOtpSession();

  const mobile = getOtpMobile();

  if (!mobile) {
    return <Navigate to="/auth/login" replace />;
  }

  return <>{children || <Outlet />}</>;
}
